import LoadClasses from "../GrapesJs/LoadClasses"

const loadClassesOnClear = (editor) => {

    editor.on('stop:command-clear-canvas', () => {
        LoadClasses(editor);
    })
}

export default loadClassesOnClear;
